import { Injectable } from '@angular/core';
import { Task } from '../models/task.model';

@Injectable({
  providedIn: 'root',
})
export class TaskTypeService {
  public isAppointment(item: Task): boolean {
    return !!item.appointment && item.appointment.uId === item.uId;
  }

  public isTask(item: Task): boolean {
    return item.type === 0 || item.type === 1;
  }

  public isOffer(item: Task): boolean {
    return item.type === 2;
  }

  public isInvoice(item: Task): boolean {
    return item.type === 3;
  }

  public isTemplate(item: Task): boolean {
    return item.isTemplate === true;
  }
}
